import { TranslationService } from '../../../services/translation.service';
import {
	NAMESPACE_RTPC_FIELD,
	ProductCharacteristicsTranslationService
} from '../../../services/product-characteristics-translation.services';
import {
	DatacenterDateFilter,
	FilterType,
	DatacenterFreeTextFilter,
	DatacenterNumericFilter,
	FilterApiRequest,
	SuggestiveListFilter,
	DropdownFilter
} from '../../../models/datacenter-filters';
import { OFFER_SERVER_URL } from '../../../../config';

const GET_PRODUCT_FIELDS_URL = `${ OFFER_SERVER_URL }/v3/products/fields`;

type FilterTypeFn = () => FilterType;

export class ProductListFiltersConfiguration {
	constructor(
		private readonly translationService: TranslationService,
		private readonly productCharacteristicsTranslationService: ProductCharacteristicsTranslationService
	) {}

	// eslint-disable-next-line @typescript-eslint/naming-convention
	PRODUCT_LIST_FILTERS = () =>
		new Map<string, FilterTypeFn>([
			[
				'userPartReference',
				() => new DatacenterFreeTextFilter(
					'userPartReference',
					this.productCharacteristicsTranslationService
						.translate(`${ NAMESPACE_RTPC_FIELD }usePartReference`),
					this.productCharacteristicsTranslationService
						.translate(`${ NAMESPACE_RTPC_FIELD }usePartReference`),
					'userPartReference'
				)
			],
			[
				'commercialSteelGradeID',
				() => new SuggestiveListFilter(
					'commercialSteelGradeID',
					this.productCharacteristicsTranslationService
						.translate(`${ NAMESPACE_RTPC_FIELD }steelGrade`),
					this.productCharacteristicsTranslationService
						.translate(`${ NAMESPACE_RTPC_FIELD }steelGrade`),
					'steelGrade',
					'steelGrade',
					new FilterApiRequest(GET_PRODUCT_FIELDS_URL)
				)
			],
			[
				'commercialMetallicCoatingID',
				() => new DropdownFilter(
					'commercialMetallicCoatingID',
					this.productCharacteristicsTranslationService
						.translate(`${ NAMESPACE_RTPC_FIELD }metallicCoating`),
					this.productCharacteristicsTranslationService
						.translate(`${ NAMESPACE_RTPC_FIELD }metallicCoating`),
					'metallicCoating',
					'metallicCoating',
					new FilterApiRequest(GET_PRODUCT_FIELDS_URL)
				)
			],
			[
				'surfaceAspect',
				() => new DropdownFilter(
					'surfaceAspect',
					this.productCharacteristicsTranslationService
						.translate(`${ NAMESPACE_RTPC_FIELD }surfaceAspect`),
					this.productCharacteristicsTranslationService
						.translate(`${ NAMESPACE_RTPC_FIELD }surfaceAspect`),
					'surfaceAspect',
					'surfaceAspect',
					new FilterApiRequest(GET_PRODUCT_FIELDS_URL)
				)
			],
			[
				'organicDatasheetNameTop',
				() => new DropdownFilter(
					'organicDatasheetNameTop',
					this.productCharacteristicsTranslationService
						.translate(`${ NAMESPACE_RTPC_FIELD }organicDatasheetNameTop`),
					this.productCharacteristicsTranslationService
						.translate(`${ NAMESPACE_RTPC_FIELD }organicDatasheetNameTop`),
					'organicDatasheetNameTop',
					'organicDatasheetNameTop',
					new FilterApiRequest(GET_PRODUCT_FIELDS_URL)
				)
			],
			[
				'colourTop',
				() => new SuggestiveListFilter(
					'colourTop',
					this.productCharacteristicsTranslationService
						.translate(`${ NAMESPACE_RTPC_FIELD }colourTop`),
					this.productCharacteristicsTranslationService
						.translate(`${ NAMESPACE_RTPC_FIELD }colourTop`),
					'colourTop',
					'colourTop',
					new FilterApiRequest(GET_PRODUCT_FIELDS_URL)
				)
			],
			[
				'strippableFilmType',
				() => new DropdownFilter(
					'strippableFilmType',
					this.productCharacteristicsTranslationService
						.translate(`${ NAMESPACE_RTPC_FIELD }strippableFilmType`),
					this.productCharacteristicsTranslationService
						.translate(`${ NAMESPACE_RTPC_FIELD }strippableFilmType`),
					'strippableFilmType',
					'strippableFilmType',
					new FilterApiRequest(GET_PRODUCT_FIELDS_URL)
				)
			],
			[
				'organicDatasheetNameBottom',
				() => new DropdownFilter(
					'organicDatasheetNameBottom',
					this.productCharacteristicsTranslationService
						.translate(`${ NAMESPACE_RTPC_FIELD }organicDatasheetNameBottom`),
					this.productCharacteristicsTranslationService
						.translate(`${ NAMESPACE_RTPC_FIELD }organicDatasheetNameBottom`),
					'organicDatasheetNameBottom',
					'organicDatasheetNameBottom',
					new FilterApiRequest(GET_PRODUCT_FIELDS_URL)
				)
			],
			[
				'colourBottom',
				() => new SuggestiveListFilter(
					'colourBottom',
					this.productCharacteristicsTranslationService
						.translate(`${ NAMESPACE_RTPC_FIELD }colourBottom`),
					this.productCharacteristicsTranslationService
						.translate(`${ NAMESPACE_RTPC_FIELD }colourBottom`),
					'colourBottom',
					'colourBottom',
					new FilterApiRequest(GET_PRODUCT_FIELDS_URL)
				)
			],
			[
				'chemicalTreatment',
				() => new DropdownFilter(
					'chemicalTreatment',
					this.productCharacteristicsTranslationService
						.translate(`${ NAMESPACE_RTPC_FIELD }chemicalTreatment`),
					this.productCharacteristicsTranslationService
						.translate(`${ NAMESPACE_RTPC_FIELD }chemicalTreatment`),
					'chemicalTreatment',
					'chemicalTreatment',
					new FilterApiRequest(GET_PRODUCT_FIELDS_URL)
				)
			],
			[
				'edgeTrimmedInLastToolCode',
				() => new DropdownFilter(
					'edgeTrimmedInLastToolCode',
					this.productCharacteristicsTranslationService
						.translate(`${ NAMESPACE_RTPC_FIELD }edgeTrimmedInLastTool`),
					this.productCharacteristicsTranslationService
						.translate(`${ NAMESPACE_RTPC_FIELD }edgeTrimmedInLastTool`),
					'edgeTrimmedInLastTool',
					'edgeTrimmedInLastTool',
					new FilterApiRequest(GET_PRODUCT_FIELDS_URL)
				)
			],
			[
				'floorPlatesPattern',
				() => new DropdownFilter(
					'floorPlatesPattern',
					this.productCharacteristicsTranslationService
						.translate(`${ NAMESPACE_RTPC_FIELD }floorPlatesPattern`),
					this.productCharacteristicsTranslationService
						.translate(`${ NAMESPACE_RTPC_FIELD }floorPlatesPattern`),
					'floorPlatesPattern',
					'floorPlatesPattern',
					new FilterApiRequest(GET_PRODUCT_FIELDS_URL)
				)
			],
			[
				'floorPlatesPatternSide',
				() => new DropdownFilter(
					'floorPlatesPatternSide',
					this.productCharacteristicsTranslationService
						.translate(`${ NAMESPACE_RTPC_FIELD }floorPlatesPatternSide`),
					this.productCharacteristicsTranslationService
						.translate(`${ NAMESPACE_RTPC_FIELD }floorPlatesPatternSide`),
					'floorPlatesPatternSide',
					'floorPlatesPatternSide',
					new FilterApiRequest(GET_PRODUCT_FIELDS_URL)
				)
			],
			[
				'lengthValue',
				() => new DatacenterNumericFilter(
					'lengthValue',
					this.productCharacteristicsTranslationService
						.translate(`${ NAMESPACE_RTPC_FIELD }lengthValue`),
					this.translationService.getTR('filter.number.from'),
					this.translationService.getTR('filter.number.to'),
					'lengthValue'
				)
			],
			[
				'strippableFilmSide',
				() => new DropdownFilter(
					'strippableFilmSide',
					this.productCharacteristicsTranslationService
						.translate(`${ NAMESPACE_RTPC_FIELD }strippableFilmSide`),
					this.productCharacteristicsTranslationService
						.translate(`${ NAMESPACE_RTPC_FIELD }strippableFilmSide`),
					'strippableFilmSide',
					'strippableFilmSide',
					new FilterApiRequest(GET_PRODUCT_FIELDS_URL)
				)
			],
			[
				'streakinessMaxInMicron',
				() => new DropdownFilter(
					'streakinessMaxInMicron',
					this.productCharacteristicsTranslationService
						.translate(`${ NAMESPACE_RTPC_FIELD }roughness`),
					this.productCharacteristicsTranslationService
						.translate(`${ NAMESPACE_RTPC_FIELD }roughness`),
					'roughness',
					'roughness',
					new FilterApiRequest(GET_PRODUCT_FIELDS_URL)
				)
			],
			[
				'betterSidePosition',
				() => new DropdownFilter(
					'betterSidePosition',
					this.productCharacteristicsTranslationService
						.translate(`${ NAMESPACE_RTPC_FIELD }betterSidePosition`),
					this.productCharacteristicsTranslationService
						.translate(`${ NAMESPACE_RTPC_FIELD }betterSidePosition`),
					'betterSidePosition',
					'betterSidePosition',
					new FilterApiRequest(GET_PRODUCT_FIELDS_URL)
				)
			],
			[
				'thicknessValue',
				() => new DatacenterNumericFilter(
					'thicknessValue',
					this.productCharacteristicsTranslationService
						.translate(`${ NAMESPACE_RTPC_FIELD }thicknessValue`),
					this.translationService.getTR('filter.number.from'),
					this.translationService.getTR('filter.number.to'),
					'thicknessValue'
				)
			],
			[
				'commercialThicknessToleranceID',
				() => new DropdownFilter(
					'commercialThicknessToleranceID',
					this.productCharacteristicsTranslationService
						.translate(`${ NAMESPACE_RTPC_FIELD }thicknessTolerance`),
					this.productCharacteristicsTranslationService
						.translate(`${ NAMESPACE_RTPC_FIELD }thicknessTolerance`),
					'thicknessTolerance',
					'thicknessTolerance',
					new FilterApiRequest(GET_PRODUCT_FIELDS_URL)
				)
			],
			[
				'thicknessToleranceMinus',
				() => new DatacenterNumericFilter(
					'thicknessToleranceMinus',
					this.productCharacteristicsTranslationService
						.translate(`${ NAMESPACE_RTPC_FIELD }thicknessToleranceMinus`),
					this.translationService.getTR('filter.number.from'),
					this.translationService.getTR('filter.number.to'),
					'thicknessToleranceMinus'
				)
			],
			[
				'thicknessTolerancePlus',
				() => new DatacenterNumericFilter(
					'thicknessTolerancePlus',
					this.productCharacteristicsTranslationService
						.translate(`${ NAMESPACE_RTPC_FIELD }thicknessTolerancePlus`),
					this.translationService.getTR('filter.number.from'),
					this.translationService.getTR('filter.number.to'),
					'thicknessTolerancePlus'
				)
			],
			[
				'varnishTop',
				() => new DropdownFilter(
					'varnishTop',
					this.productCharacteristicsTranslationService
						.translate(`${ NAMESPACE_RTPC_FIELD }varnishTop`),
					this.productCharacteristicsTranslationService
						.translate(`${ NAMESPACE_RTPC_FIELD }varnishTop`),
					'varnishTop',
					'varnishTop',
					new FilterApiRequest(GET_PRODUCT_FIELDS_URL)
				)
			],
			[
				'varnishBottom',
				() => new DropdownFilter(
					'varnishBottom',
					this.productCharacteristicsTranslationService
						.translate(`${ NAMESPACE_RTPC_FIELD }varnishBottom`),
					this.productCharacteristicsTranslationService
						.translate(`${ NAMESPACE_RTPC_FIELD }varnishBottom`),
					'varnishBottom',
					'varnishBottom',
					new FilterApiRequest(GET_PRODUCT_FIELDS_URL)
				)
			],
			[
				'primerTop',
				() => new DropdownFilter(
					'primerTop',
					this.productCharacteristicsTranslationService
						.translate(`${ NAMESPACE_RTPC_FIELD }primerTop`),
					this.productCharacteristicsTranslationService
						.translate(`${ NAMESPACE_RTPC_FIELD }primerTop`),
					'primerTop',
					'primerTop',
					new FilterApiRequest(GET_PRODUCT_FIELDS_URL)
				)
			],
			[
				'primerBottom',
				() => new DropdownFilter(
					'primerBottom',
					this.productCharacteristicsTranslationService
						.translate(`${ NAMESPACE_RTPC_FIELD }primerBottom`),
					this.productCharacteristicsTranslationService
						.translate(`${ NAMESPACE_RTPC_FIELD }primerBottom`),
					'primerBottom',
					'primerBottom',
					new FilterApiRequest(GET_PRODUCT_FIELDS_URL)
				)
			],
			[
				'commercialTOCTypeTopID',
				() => new DropdownFilter(
					'commercialTOCTypeTopID',
					this.productCharacteristicsTranslationService
						.translate(`${ NAMESPACE_RTPC_FIELD }thinOCTop`),
					this.productCharacteristicsTranslationService
						.translate(`${ NAMESPACE_RTPC_FIELD }thinOCTop`),
					'thinOCTop',
					'thinOCTop',
					new FilterApiRequest(GET_PRODUCT_FIELDS_URL)
				)
			],
			[
				'commercialTOCTypeBottomID',
				() => new DropdownFilter(
					'commercialTOCTypeBottomID',
					this.productCharacteristicsTranslationService
						.translate(`${ NAMESPACE_RTPC_FIELD }thinOCBottom`),
					this.productCharacteristicsTranslationService
						.translate(`${ NAMESPACE_RTPC_FIELD }thinOCBottom`),
					'thinOCBottom',
					'thinOCBottom',
					new FilterApiRequest(GET_PRODUCT_FIELDS_URL)
				)
			],
			[
				'nominalThicknessValueTop',
				() => new DatacenterNumericFilter(
					'nominalThicknessValueTop',
					this.productCharacteristicsTranslationService
						.translate(`${ NAMESPACE_RTPC_FIELD }nominalThicknessValueTop`),
					this.translationService.getTR('filter.number.from'),
					this.translationService.getTR('filter.number.to'),
					'nominalThicknessValueTop'
				)
			],
			[
				'nominalThicknessValueBottom',
				() => new DatacenterNumericFilter(
					'nominalThicknessValueBottom',
					this.productCharacteristicsTranslationService
						.translate(`${ NAMESPACE_RTPC_FIELD }nominalThicknessValueBottom`),
					this.translationService.getTR('filter.number.from'),
					this.translationService.getTR('filter.number.to'),
					'nominalThicknessValueBottom'
				)
			],
			[
				'widthValue',
				() => new DatacenterNumericFilter(
					'widthValue',
					this.productCharacteristicsTranslationService
						.translate(`${ NAMESPACE_RTPC_FIELD }widthValue`),
					this.translationService.getTR('filter.number.from'),
					this.translationService.getTR('filter.number.to'),
					'widthValue'
				)
			],
			[
				'lastUsed',
				() => new DatacenterDateFilter(
					'lastUsed',
					this.translationService.getTR('eorder.product.lastused'),
					this.translationService.getTR('filter.date.from'),
					this.translationService.getTR('filter.date.to'),
					'lastUsed',
					'date'
				)
			],
		]);
}
